import { render, staticRenderFns } from "./UndispatchReasonModal.vue?vue&type=template&id=100b1377&scoped=true&"
import script from "./UndispatchReasonModal.vue?vue&type=script&lang=js&"
export * from "./UndispatchReasonModal.vue?vue&type=script&lang=js&"
import style0 from "./UndispatchReasonModal.vue?vue&type=style&index=0&id=100b1377&lang=scss&scoped=true&"
import style1 from "./UndispatchReasonModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100b1377",
  null
  
)

export default component.exports